<!-- 상품구매 페이지 -->
<template>
<div id="payment_seat">
    <div class="pay_process">
    <div class="pay_process_wrap">
        <!-- 왼쪽 메뉴 -->
        <div class="progress-bar-wrap">
            <div class="progress-bar">
                <div class="bar">
                    <div class="_fill"></div>
                </div>
                <div class="point" v-for="(item, index) in left_menu_list" 
                :key="'left_menu'+index" 
                :class="item['active_class']">
                    <div class="bullet">
                        <img :src="item.img_src">
                    </div>
                    <label class="label">{{item.menu_name}}</label>
                </div>
            </div>
        </div>
        <!-- 오른쪽 메뉴1 -->
        <div class="process_content">
            <!-- 오른쪽 메뉴2 -->
            <div class="pay_content_wrap">
                <!-- 기타상품 타입 선택 -->
                <div class="pay_content_01 pay_content"  v-if="step==0">
                    <div class="paytit">
                        </div>
                    <ul>
                        <li v-for=" (item , index) in etc_product_list" :key="'pay_content_00'+index" 
                        :class="item['active_class']" @click="set_etc_product(item ,index)">
                            <div>{{item.goods_name}}</div>
                        </li>
                    </ul>
                </div><!-- 기타상품 타입 선택 -->

                <!-- 상품타입 -->
                <!--
                <div class="pay_content_01 pay_content" v-if="step==1">
                    <div class="paytit">
                        </div>
                    <ul>
                        <template>
                        <li :class="{'pay-content-on': isContentOn}"
                        @click="isContentOn = !isContentOn">
                            <div>{{ goods_type_name }}</div>
                        </li>
                        </template>
                    </ul>
                </div>
                --><!-- 상품타입 -->

                <!-- 시간선택 -->
                <!--
                <div class="pay_content_01 pay_content" v-if="step==2">
                    <div class="paytit">
                    </div>
                    <ul>
                        <li v-for=" (item , index) in etc_product_time_list" 
                        :key="'pay_content01'+index" 
                        :class="item['active_class']" @click="set_etc_product_time(item, index)">
                            <template>
                                {{item.goods_name}}
                            </template>
                        </li>
                    </ul>
                </div>--><!-- 시간선택  -->

                <!-- 마일리지 -->
                <!--
                <div class="pay_content_05 pay_content" v-if="step==3 && mileage_use_yn == 1">
                    <div class="paytit"></div>
                    <ul class="hidden-scroll">
                        <template v-if="mileage_chk === false">
                            <li @click="set_mileage(false)" class="pay-content-on" >
                                <div>마일리지미사용</div>
                            </li>
                            <li @click="set_mileage(true)">
                                <div>마일리지사용</div>
                            </li>
                        </template>
                        <template v-else>
                            <li @click="set_mileage(false)" >
                                <div>마일리지미사용</div>
                            </li>
                            <li @click="set_mileage(true)" class="pay-content-on">
                                <div>마일리지사용</div>
                            </li>
                        </template>
                    </ul>
                    <template v-if="mileage_chk === true">
                        <div class="mg_box_wrap  hidden-scroll" >
                            <div>
                                <span>적립금액 :</span>
                                <mileage @milage="milage_payment" />
                            </div>

                            <div>
                                <span>적용금액 :</span>
                                <span>{{use_mileage.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                            </div>
                            <ul>
                                <li @click="set_mileage_button(use_min_unit)">+ {{(use_min_unit).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</li>
                                <li @click="set_mileage_button(use_min_unit*2)">+ {{(use_min_unit*2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</li>
                                <li @click="set_mileage_button(use_min_unit*10)">+ {{(use_min_unit*10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</li>
                                <li @click="set_mileage_button('all')">전체적용</li>
                                <li @click="set_mileage_button('cancel')">전체취소</li>
                            </ul>

                            <p>※ 최소사용단위 : {{use_min_unit}}원    ※ 최소사용금액 : {{use_min_amount}}원</p>
                        </div>
                    </template>

                </div>--> <!-- 마일리지 -->

                <!-- 할인쿠폰 -->
                 <!--
                <div class="pay_content_06 pay_content" v-if="step==4 && sale_use_yn == 1">
                    <div class="paytit"></div>
                    <ul class="hidden-scroll">
                        <template v-if="discount_coupon === true">
                            <li @click="set_discount_coupon(false)" >
                                <div>할인쿠폰미사용</div>
                            </li>
                            <li @click="set_discount_coupon(true)" class="pay-content-on">
                                <div>할인쿠폰사용</div>
                            </li>
                        </template>
                        <template v-else>
                            <li @click="set_discount_coupon(false)" class="pay-content-on">
                                <div>할인쿠폰미사용</div>
                            </li>
                            <li @click="set_discount_coupon(true)" >
                                <div>할인쿠폰사용</div>
                            </li>
                        </template>
                    </ul>
                    <template v-if="discount_coupon === true">
                        <div class="cp_box_wrap">
                            <div class="cp_box">
                                <span>쿠폰코드 :</span>
                                <span>{{discount_coupon_code | coupon_filter}}</span>
                            </div>
                            <button @click="coupon_check()">적용</button>
                        </div>

                        <div class="cp_num_pad">
                            <div class="pad_btn">
                                <span @click="coupoun_input('1')">1</span>
                                <span @click="coupoun_input('2')">2</span>
                                <span @click="coupoun_input('3')">3</span>
                                <span @click="coupoun_input('4')">4</span>
                                <span @click="coupoun_input('5')">5</span>
                                <span @click="coupoun_input('6')">6</span>
                            </div>
                            <div class="pad_btn">
                                <span @click="coupoun_input('7')">7</span>
                                <span @click="coupoun_input('8')">8</span>
                                <span @click="coupoun_input('9')">9</span>
                                <span @click="coupoun_input('0')">0</span>
                                <span @click="coupoun_input('del')"><img src='../../assets/image/delete_gy.png'></span>
                            </div>

                        </div>
                    </template>

                </div>--> <!-- 할인쿠폰 -->

                <!-- 결제 전 환불안내 -->
                <div class="pay_content_06 pay_content" v-if="step==5" style="overflow: hidden">
                  <template v-if="refund !='' && refund != undefined">
                    <p>환불규정</p>
                    <br>
                    <textarea readonly disabled style="width: 100%;height: 100%;border: none;">{{ refund }}</textarea>
                  </template>
                </div>
                <!-- 결제 완료 -->
                <div class="pay_content_09 pay_content" v-if="step==6">
                    <div class="finish_payment_wrap">
                        <div class="finish_head" v-if="last_price_card != 0">
                            <ul>
                                <li>
                                    <span class="pay_hd">결제금액</span>
                                    <span class="pay_ft">{{last_price_card}} 원</span>
                                </li>
                            </ul>
                        </div>

                        <div class="finish_body">
                            <p v-if="last_price_card != 0">결제가 완료되었습니다. </p>
                            <img src="../../assets/image/barcode_img.jpg">
                            <p>입력하신 휴대폰 번호로 <br><span>결제 정보</span>가 담긴 문자가 전송됩니다.
                            <!-- 250514 이용안내 팝업 추가 -->
                            <div v-if="usage_guide_useyn=='y'" class="guide_btn_wrap">
                                <div class="guide_btn" @click="open_guide()">이용안내</div>
                            </div>

                            </p>
                        </div>

                        <div class="finish_footer pay_content_btn">
                            <div class="ok_btn" @click="step_finish(-1)">확인</div>
                        </div>
                    </div>
                </div><!-- 결제 완료 -->
            </div><!-- 오른쪽 메뉴2 -->
            <div class="pay_info" v-if="step <= 5">
                <div class="pay_info_wrap" >
                    <div class="pay_wrap">
                        <ul>
                            <li>
                                <div class="pay_hd">상품명</div>
                                <div class="pay_ft">{{ goods_name }}</div>
                            </li>
                            <li>
                                <div class="pay_hd">상품종류</div>
                                <!-- <div class="pay_ft">{{seat_goods_group_name}}</div> -->
                                <div class="pay_ft">기타상품</div>
                            </li>
                            <li>
                                <div class="pay_hd">이용시간</div>
                                <!-- <div class="pay_ft">{{seat_goods_item_name}}{{sub_product_name}}</div> -->
                                <div class="pay_ft">{{goods_time}}</div>
                            </li>
                            <!--<li>
                                <div class="pay_hd">만료일자</div>
                                <div class="pay_ft">{{end_date}}</div>
                            </li>-->
                            <li>
                                <div class="pay_hd">상품구분</div>
                                <div class="pay_ft">{{division}}</div>
                            </li>
                            <!--
                            <li v-if="mileage_use_yn == 1">
                                <div class="pay_hd">마일리지</div>
                                <div class="pay_ft price">{{use_mileage.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}{{mileage_text}}</div>
                            </li>
                            <li v-if=" sale_use_yn == 1">
                                <div class="pay_hd">할인금액</div>
                                <div class="pay_ft price">{{discounted_price_card}}{{discount_text}}</div>
                            </li>
                            -->
                            <li>
                                <div class="pay_hd">결제금액</div>
                                <div class="pay_ft price">{{last_price_card}}{{price_text}}</div>
                            </li>
                        </ul>
                    </div>
                    <div class="pay_content_btn" v-if="step == 0">
                        <div class="prev_btn" @click="step_controll_back()" v-if="step!=7 && step!=8 && step!=15">
                            이전
                        </div>
                        <!-- <div class="next_btn" @click="step_controll(1)" v-if="step!=7 && step!=8 && step!=15"> -->
                        <div class="next_btn" @click="step_controll(5)" v-if="step!=7 && step!=8 && step!=15">
                            다음
                        </div>
                    </div>
                    <!--
                    <div class="pay_content_btn" v-if="step == 1">
                        <div class="prev_btn" @click="step_controll_back()" v-if="step!=7 && step!=8 && step!=15">
                            이전
                        </div>
                        <div class="next_btn" @click="step_controll(1)" v-if="step!=7 && step!=8 && step!=15">
                            다음
                        </div>
                    </div>
                    <div class="pay_content_btn" v-if="step == 2">
                        <div class="prev_btn" @click="step_controll_back()" v-if="step!=7 && step!=8 && step!=15">
                            이전
                        </div>
                        <div class="next_btn" @click="step_controll(1)" v-if="step!=7 && step!=8 && step!=15">
                            다음
                        </div>
                    </div>
                    <div class="pay_content_btn" v-if="step==3 && mileage_use_yn == 1">
                        <div class="prev_btn" @click="step_controll_back()" v-if="step!=7 && step!=8 && step!=15">
                            이전
                        </div>
                        <div class="next_btn" @click="step_controll(1)" v-if="step!=7 && step!=8 && step!=15">
                            다음
                        </div>
                    </div>
                    <div class="pay_content_btn" v-if="step==4 && sale_use_yn == 1">
                        <div class="prev_btn" @click="step_controll_back()" v-if="step!=7 && step!=8 && step!=15">
                            이전
                        </div>
                        <div class="next_btn" @click="step_controll(1)" v-if="step!=7 && step!=8 && step!=15">
                            다음
                        </div>
                    </div>
                    -->
                    <div class="pay_content_btn" v-if="step == 5">
                        <div class="prev_btn" @click="step_controll_back()">이전</div>
                        <div class="next_btn" @click="do_pay_check()">결제하기</div>
                    </div>
                </div>
            </div>
        </div><!-- 오른쪽 메뉴1 -->
    </div><!-- 왼쪽 메뉴 -->
    </div>
</div>
</template>

<script>
var self = this;
import vue from 'vue';
import * as config from '../../javascript/config';

// 결제모듈
// import external from '@/assets/js/external.js';
import moment from 'vue-moment';

vue.use(moment);
export default {
    data: function () {
        return {
            step: 0,
            left_menu_list: [],

            now_date: '',
            end_date: null,
            end_date_for_server: null,
            user_id: '',

            //결제관련
            time: 'no',

            // 상품 목록 관련
            type_name: "",
            before_goods_type_id: '',
            etc_goods_id: 0,
            etc_product_list: [],
            goods_name : "",
            // 상품 시간 목록 관련
            use_hours: '',
            goods_time: '',
            cash_amount: '',
            card_amount: '',
            today_use_hours: '',
            use_end_datetime: null,
            use_start_datetime: null,
            product_division: '',

            // 결제방법
            cash: true, 
            card_amount: '',
            mileage_save_yn: '',
            seat_event_goods_id: null,
            division:'',
            card_installment: 0, // 0 = 일시불 2 = 2개월 13 = default
            cash_receipt: '0', // 0 == 개인(소득공제) 1 == 법인(지출증빙)
            cash_receipt_flag:false,
            //마일리지
            mileage_use_yn: '', //해당 매장에서 마일리지 사용여부
            mileage_chk: false,
            mileage_id: null,
            my_save_mileage: 0,
            milage_all: false,
            use_mileage: '',
            //할인쿠폰
            sale_use_yn: '', //해당 매장에서 할인쿠폰 사용여부
            discount_coupon: false,
            discount_coupon_code: '',
            sale_id: 0,
            sale_rate: 0,
            discounted_price_card: '',
            discount_flag: false,

            // 내 좌석 상품 , 쿠폰
            my_seat_product_list: [],
            my_coupon_list: [],

            last_price_card: '',

            // 마일리지 사용 최소 단위
            use_min_unit: 0,
            // 마일리지 사용 최소 금액
            use_min_amount: 0,

            // 잔돈 방출 시 다음스텝으로 진행할 지 여부
            payment_return_kind: false,
            // 결제 진행 도중 취소버튼 안보이게
            btn_display_status: "inline-block",

            // 결제 정보 관련
            app_number: 0,         // 승인번호
            payment_kind_name: '',  // 현금 : 종류, 카드 : 카드사명
            card_number: '',        // 카드번호(현금영수증번호)

            special_goods_flag : false, // 시간충전권 , 기간권 , 1일시간권 이 아닌 주간권,야간권,주간기간권,야간기간권을 체크하기위한 flag
            mileage_text: '',
            discount_text: '',
            price_text: '',
            refund: '',  // 환불규정

            usage_guide_useyn: 'n', //이용안내 사용여부
            usage_guide_data: null, //이용안내 데이터
            isContentOn : true,
        }
    },
    filters:{
        coupon_filter(value){
            var num = new Number(value);
            num = num.toFixed(0).replace(/\B(?=(\d{4})+(?!\d))/g, "-");
            return `${num}`
        }
    },
    props: [
        'hot_table',
    ],
    methods: {
        step_finish() {
            var router = this.$router;
            router.push('/');
        },
        step_controll(val) {
            this.step += val;
            //기타 상품은 바로 결제로
            /*
            if (this.mileage_use_yn != 1 && this.sale_use_yn != 1 && this.step == 4) {
                this.step = 5;
            }
                */

            // 1. 상품 선택
            if (this.step == 5 && this.etc_goods_id == 0) {
                // 상품(타입)이 선택되지 않으면 뒤로
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `상품을 선택해 주세요.`,
                    router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
                this.step = 0;
                return;
            } else {
                // 기타상품 리스트 세팅
                this.goods_type_name = '기타상품';
                // 기타상품 리스트
                const type = config.REQ_ETC_GOODS_GET_LIST;
                const data = {}; 
                this.$store.dispatch(type.action_name, {
                    type: type,
                    data: data
                }).then(response => {
                    this.etc_product_list = response.data;
                    if(this.etc_product_list.length != 0){
                        for(var i = 0; i < this.etc_product_list.length; i++){
                            this.etc_product_list[i].active_class = '';
                        }
                    }
                }).catch(function (error) {
                    console.log('error=============>', error);
                });
            }

            //2. 시간선택
            /*
            if (this.step == 2 && this.groom_goods_group_id == 0) {
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `타입을 선택해 주세요.`,
                    router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
                this.step -= 1;
                this.step_controll_back();
                return;
            }
            if (this.step == 3 && this.groom_goods_id == '') {
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `시간을 선택해주세요.`,
                    router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
                this.step -= 1;
                return;
            }
                

            if (this.mileage_use_yn == 1 && this.step == 4) {
                if(this.mileage_chk){
                    if(this.use_mileage < this.use_min_amount){
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `마일리지가 최소 금액보다 부족합니다.`,
                            router: '',
                        };
                        this.$store.commit('set_popup_type', alert_param);
                        this.step -= 1;
                        return;
                    }
                }
                if(this.use_mileage == this.card_amount.replace(/,/g,"")){
                    this.step = 5;
                }
            }

            if (this.milage_all && this.step == 4) {

                var card = 0;
                card = this.card_amount.replace(/,/g,"");

                card = card - Number(this.my_save_mileage) * 1;

                // this.last_price_card = card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                this.use_mileage = Number(this.my_save_mileage) * 1;
            }

            if (this.step == 4 && this.use_mileage > 0) {
                var card = 0;
                card = this.card_amount.replace(/,/g,"");

                let amount = card;

                if(amount < this.use_mileage){
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `마일리지가 결제 금액보다 큽니다.`,
                        router: '',
                    };
                    this.$store.commit('set_popup_type', alert_param);
                    this.step -= 1;
                    this.use_mileage = 0;
                    return;
                }else{
                    card = card - this.use_mileage;
                    if(card == 0){
                        this.last_price_card = card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        // this.step = 7;
                    }
                    // this.last_price_card = card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
            }
            */
            if (this.step == 5) {
                if(this.discount_coupon && !this.discount_flag){
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `쿠폰코드를 입력해주세요. `,
                        router: '',
                    }
                    this.$store.commit('set_popup_type', alert_param);
                    this.step--;
                    return;
                }

                //여기 추가되는게 맞나? 
                this.last_price_card = this.card_amount;
            }
            /*
            if (this.mileage_use_yn != 1 && this.step == 3) {
                this.step = 4;
            }

            if (this.sale_use_yn != 1 && this.step == 4) {
                this.step = 5;
            }
            */
        },
        step_controll_back() {
            this.step -= 1;
            /*
            if(this.mileage_chk && this.last_price_card == 0){
                this.step = 3;
            }
            */
            //기타상품은 결제 이전으로 돌아갈 때 처음 스텝으로
            if (this.step == 4) {
                this.step = 0;
            }

            if (this.step == -1) {
                var router = this.$router;
                var last_url = this.$store.getters['get_last_url'];
                if (last_url == undefined ||
                    last_url == null ||
                    last_url == '' ||
                    last_url == 'undefined' ||
                    last_url == 'null' ||
                    last_url.length == 0) {
                    router.push('/');
                } else {
                    router.push(last_url); // 이동 위치를 입력
                }
            }
            /*
            if(this.mileage_use_yn != 1 && this.sale_use_yn != 1 && this.step == 4) {
                this.step = 2;
            }
            if(this.sale_use_yn != 1 && this.step == 4){
                this.step = 3;
            }

            if(this.mileage_use_yn != 1 && this.step == 3){
                this.step = 2;
            }

            if(this.step == 3){
                if(this.use_mileage > 0){
                    this.mileage_chk = true;
                }else{
                    this.mileage_chk = false;
                }
            }
            if(this.step == 2){
                this.card_amount = '';
                this.last_price_card = '';
                this.price_text = ''; 
                this.end_date = '';
                this.division = '';
                this.use_mileage = '';
                this.mileage_text = '';
                this.discounted_price_card = '';
                this.discount_text = '';
                this.discount_flag = false;
                this.mileage_chk = false;
                this.discount_coupon = false;
                this.discount_coupon_code = '';

                this.groom_goods_id = '';
                this.groom_goods_name = '';
                this.goods_time = '';
                this.goods_type_name = '';
                // this.type_name = '';
                //this.groom_product_time_list = [];
                for(var i = 0; i<this.groom_product_time_list.length; i ++){
                    this.groom_product_time_list[i].active_class= "";
                }
            }
            if(this.step == 1){
                this.card_amount = '';
                this.last_price_card = '';
                this.price_text = '';
                this.end_date = '';
                this.division = '';
                for(var i = 0; i<this.groom_product_time_list.length; i ++){
                    this.groom_product_time_list[i].active_class= "";
                }

                this.groom_goods_id = '';
                this.groom_goods_name = '';
                this.groom_goods_group_id ='';
                this.groom_type_id = '';
                this.goods_time = '';

                for(var i = 0; i<this.groom_product_list.length; i ++){
                    this.groom_product_list[i].active_class= "";
                }
            }
            */

            if(this.step == 0){
                // 타입선택 리셋
                this.etc_goods_id = '';
                this.goods_name = '';
                this.type_name = '';
                this.card_amount = '';
                this.cash_amount = '';
                this.last_price_card = this.card_amount;

                for(var i = 0; i<this.etc_product_list.length; i ++){
                    this.etc_product_list[i].active_class= "";
                }
            }

        },
        set_etc_product(item, index){
            //this.etc_product_list = []; //다른 상품 선택 시 초기화
            for(var i = 0; i<this.etc_product_list.length; i++){
                this.etc_product_list[i].active_class = "";
            }
            this.etc_product_list[index].active_class = "pay-content-on";

            this.goods_name = item.goods_name;
            this.etc_goods_id = typeof item.etc_goods_id !== 'undefined' ? item.etc_goods_id : null;
            this.card_amount = item.card_amount;
            this.cash_amount = item.cash_amount;
            this.last_price_card = this.card_amount;
            this.pay_type_str = '카드결제'; // defalt 카드결제
            this.choice_use_time_list = [];
            this.price_text = '원';

            // 기타상품 타입 리스트 재세팅
            /*
            const type = config.REQ_ETC_GOODS_GET_LIST;
            const data = {}; // store_id는 공통으로 추가하니까 생략. 예) {user_id: 123}
            this.$store.dispatch(type.action_name, {
                type: type,
                data: data
            }).then(response => {
                this.etc_product_list = response.data;
                if(this.etc_product_list.length != 0){
                    for(var i = 0; i < this.etc_product_list.length; i++){
                        this.etc_product_list[i].active_class = '';
                    }
                }
            }).catch(function (error) {
                console.log('error=============>', error);
            });
            */
        },
        set_mileage(type) {
            if(type){
                this.mileage_chk = true;
                this.use_mileage = 0;
                this.mileage_text = '원';
            }else{
                if(!this.discount_flag){
                    this.last_price_card = this.card_amount;
                }else{
                    let calcul_payment = parseInt(this.last_price_card.replace(/,/g,"")) + this.use_mileage
                    this.last_price_card = calcul_payment.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
                this.use_mileage = '';
                this.mileage_text = '';
                this.mileage_chk = false;
            }
        },
        set_mileage_button(value) {
            if(this.use_min_amount > this.my_save_mileage){
                let use_min_amount_text = this.use_min_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `${use_min_amount_text} 마일리지 이상부터 사용 가능합니다.`,
                    router: '',
                    image_type : 'warning'
                };
                this.$store.commit('set_popup_type', alert_param);

                this.use_mileage = 0;
                return false;
            }
            
            if(typeof value === 'number'){
                this.use_mileage += parseInt(value);
            }else {
                this.use_mileage =  this.my_save_mileage;
            }

            if (this.use_mileage > this.my_save_mileage) {
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `사용하시려는 마일리지가 보유하고계신 마일리지보다 큽니다`,
                    router: '',
                    image_type : 'warning'
                };
                this.$store.commit('set_popup_type', alert_param);

                this.use_mileage -= value;
                return;
            }

            let amount = this.pay_type === 0 ? this.last_price_cash : this.last_price_card;

            var remain_pay = parseInt(parseInt(amount.replace(/,/g,""))/this.use_min_unit)*this.use_min_unit;
            if(value === 'all'){
                this.use_mileage = this.my_save_mileage;
                if(this.use_mileage == 0 || this.use_mileage == '0'){
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `보유하고 계신 마일리지가 없습니다.`,
                        router: '',
                        image_type : 'warning'
                    };
                    this.$store.commit('set_popup_type', alert_param);
                }

                if(remain_pay > this.use_mileage){
                    remain_pay = parseInt(this.use_mileage/this.use_min_unit)*this.use_min_unit;
                    this.use_mileage = remain_pay;
                }


                if(this.use_min_amount > this.use_mileage || remain_pay > this.use_mileage){
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `보유하고 계신 마일리지가 충분하지않습니다.`,
                        router: '',
                        image_type : 'warning'
                    };
                    this.$store.commit('set_popup_type', alert_param);
                    this.use_mileage = 0;
                }
            }else if(value === 'cancel'){
                this.use_mileage = 0;
                this.last_price_card = this.card_amount;
                return false;
            }

            if(amount.replace(/,/g,"") < this.use_mileage){
                this.use_mileage = remain_pay;
            }

            var card = 0; 
            card = this.card_amount.replace(/,/g,"");
            card = card - Number(this.use_mileage) * 1;
            this.last_price_card = card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        },
        milage_payment(mileage_data, mileage_id) {
            this.mileage_id = mileage_id;
            this.my_save_mileage = mileage_data;
        },
        set_discount_coupon(type) {
            if(type){
                this.discount_coupon = true;
                this.discounted_price_card = '0';
                this.discount_text = '원';
            }else{
                this.discount_coupon = false;
                this.discount_flag = false;
                if(this.discounted_price_card != 0){
                    this.last_price_card = (parseInt(this.last_price_card.replace(/,/g,"")) + parseInt(this.discounted_price_card.replace(/,/g,""))).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
                this.discounted_price_card = '';
                this.discount_text = '';
                this.discount_coupon_code = '';
            }
        },
        coupon_check() {
            //할인쿠폰 적용 여부
            if (this.discount_coupon) {

                const type = config.REQ_COUPON_GET;
                const data = {
                    'sale_code': this.discount_coupon_code.toString().replace(/\B(?=(\d{4})+(?!\d))/g, "-")
                };
                this.$store.dispatch(type.action_name, {
                    type: type,
                    data: data
                }).then(response => {
                    var result;
                    result = response.result;
                    if (result && !this.discount_flag && response.data.message) {
                        this.sale_id = response.data.data[0].sale_id;
                        this.sale_rate = response.data.data[0].sale_rate;

                        var price_card = this.last_price_card.replace(/,/g,"");
                        //할인된 금액
                        var discounted_price_card = Math.round(price_card * (this.sale_rate / 100));
                        // 계산된 최종금액
                        var new_price_card = price_card - discounted_price_card;
                        //최종금액
                        this.last_price_card = new_price_card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        //할인된 최종금액
                        this.discounted_price_card = discounted_price_card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                        // this.step++;
                        this.discount_flag = true;
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `할인쿠폰이 적용되었습니다. `,
                            router: '',
                        }
                        this.$store.commit('set_popup_type', alert_param);
                    } else if (!result) {
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `쿠폰코드를 다시한번 확인해주세요. `,
                            router: '',
                        }
                        this.$store.commit('set_popup_type', alert_param);
                    } else if (result && this.discount_flag) {
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `할인쿠폰이 이미 적용되어있습니다. `,
                            router: '',
                        }
                        this.$store.commit('set_popup_type', alert_param);
                    } else {
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `쿠폰코드를 다시한번 확인해주세요. `,
                            router: '',
                        }
                        this.$store.commit('set_popup_type', alert_param);
                    }
                }).catch(function (error) {
                    console.log('error=============>', error);
                });
            }
        },
        do_pay_check(){
            let self = this;
            if(this.last_price_card == 0){
                let result = {
                    "cno" : null,
                    "pay_type" : null
                };
                self.do_pay(result);
            }else{
                // 결제모듈
                var pay_info = {
                    mall_id : this.$store.getters['getStoreInfo'].store_imp_code, // 가맹점 ID
                    // mall_id : 'T5102001', // 가맹점 ID
                    mall_nm : this.$store.getters['getStoreInfo'].store_name, // 가맹점명
                    product_nm : this.goods_name + '_M', // 상품이름
                    product_amt : 
                    this.last_price_card != 0 
                    ? String(this.last_price_card).replace(/,/g,"")  
                    : this.last_price_card, // 결제금액
                    product_expr : "", // 서비스기간 : YYYYMMDD, 예) 20201231
                    user_id : this.$store.getters['getUser'].user_hp, // 가맹점 고객 ID(가맹점 고객 번호)
                    user_no : this.$store.getters['getUser'].user_id, // 가맹점 고객 일련번호
                    user_nm : this.$store.getters['getUser'].name, // 가맹점 고객명
                    user_phone : this.$store.getters['getUser'].user_hp, // 가맹점 고객 번호
                    sp_user_define1 : this.$store.getters['getStoreInfo'].store_id, // 가맹점 아이디
                    sp_user_define2 : this.$store.getters['getStoreInfo'].store_name // 가맹점 이름
                }
                var callbackTemplate = function(command, result){
                    if(result.res_cd == '0000'){
                        self.do_pay(result);
                    }else{
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: result.res_msg,
                            router: '',
                        }
                        this.$store.commit('set_popup_type', alert_param);
                    }
                };
                mobileBriddgeConn(pay_info, callbackTemplate);
            }

        },
        do_pay(result) {
            var self = this;

            var payment_kind_code;
            var payment_amount;
            var goods_amount;
            var sale_amount;
            var card_div;

            //현금 / 카드 사용여부 체크 그에따른 값 셋팅
            payment_kind_code = 'CARD';
            payment_amount = this.last_price_card == 0 ? this.last_price_card : this.last_price_card.replace(/,/g,"");
            goods_amount = this.card_amount;
            sale_amount = this.discounted_price_card;
            card_div = this.card_installment // 1 = 일시불 2 = 2개월
            goods_amount =  String(goods_amount).replace(/,/g,"");

            // 마일리지 사용여부 체크
            var mileage = {};

            if (this.mileage_chk) {
                mileage = {
                    'total_amount': Number(this.my_save_mileage) - this.use_mileage, // '나의 마일리지총액', => 나의 마일리지총액 - 마일리지 사용 금액
                    'change_amount': this.use_mileage // '변동_금액',  => 마일리지 사용 금액
                }
            }

            //할인쿠폰 사용여부 체크
            var sale = {};

            if (this.discount_coupon && this.discount_flag) {
                sale = {
                    'sale_id': this.sale_id
                }
                sale_amount = sale_amount.replace(/,/g,"");
            } else {
                sale_amount = '';
                this.sale_id = null;
            }
            //사용 종료시간 무제한 체크
            if (this.end_date == '무제한') {
                this.end_date_for_server = '0000-00-00 00:00:00';
            }

            if(!this.cash_receipt_flag){
                this.cash_receipt = '0';
            }

            const type = config.REQ_ETC_PAYMENT_INSERT; //추가해야함
            const data = {
                'data': {
                    'mileage_yn': self.mileage_chk, //'마일리지_사용_여부', Y or N
                    'sale_yn': self.discount_coupon, // 할인쿠폰 사용여부
                    'purchase_type': 'ETC', //'구매_타입',
                    'dirUseCheck': false, //false 상품구매 true 즉시사용
                    'exten_yn':false, // 연장 구매 여부
                    'mobile_yn': true, // 모바일 여부
                    'mileage_save_yn': self.mileage_save_yn, // 상품별 마일리지 적립 여부

                    'payment': {
                        'sale_id': self.sale_id, //'할인권_ID'
                        'payment_kind_code': payment_kind_code, // 현금인지 카드인지
                        'payment_status_code': 'COMPLETE',
                        'goods_type_code': 'ETC',
                        'approval_number': self.app_number,
                        'payment_amount': payment_amount * 1,
                        'goods_amount': goods_amount * 1,
                        'sale_amount': sale_amount * 1,
                        'card_div': card_div,
                        'payment_kind_name': self.payment_kind_name,    // 카드사명
                        'card_number': self.card_number,                // 카드번호
                        'goods_name': this.goods_name + '_M',
                        'cash_receipt':self.cash_receipt, // 현금 영수증
                        'cno': result.cno,
                        'pay_type': result.pay_type
                    },

                    // 마일리지_사용_여부가 'Y'일때
                    mileage: mileage,

                    // 할인쿠폰_적용_여부가 'Y'일때
                    'sale': sale,

                    'purchase': {
                        etc_goods_id: this.etc_goods_id
                    }
                }
            };
            //console.log(data)
            self.$store.dispatch(type.action_name, {
                type: type,
                data: data
            }).then(response => {
                self.step_controll(1);
            }).catch(function (error) {
                console.log('error=============>', error);
            });

        },
        // 쿠폰입력
        coupoun_input(type_num){
            if(type_num == 'del'){
                if(this.discount_coupon_code.length != 0){
                    this.discount_coupon_code = this.discount_coupon_code.substr(0, this.discount_coupon_code.length-1);
                }
            }else{
                if(this.discount_coupon_code.length <= 11){
                    this.discount_coupon_code = this.discount_coupon_code + type_num;
                }else{
                    return false;
                }
            }
        },
        get_left_menu(){
            this.left_menu_list =  [];
            this.left_menu_list.push({active_class: "process_on", img_src:  require("../../assets/image/process01_on.png"), menu_name : "타입선택" , nomal_step : 1});
            //this.left_menu_list.push({active_class: "", img_src:  require("../../assets/image/process02_on.png"), menu_name : "상품선택" , nomal_step : 2});
            //this.left_menu_list.push({active_class: "", img_src:  require("../../assets/image/process03_on.png"), menu_name : "시간선택" , nomal_step : 3});
            if(this.mileage_use_yn !=0){
                this.left_menu_list.push({active_class: "", img_src:  require("../../assets/image/process04_on.png"), menu_name : "마일리지" , nomal_step : 4});
            }
            if(this.sale_use_yn != 0){
                this.left_menu_list.push({active_class: "", img_src:  require("../../assets/image/process05_on.png"), menu_name : "할인쿠폰" , nomal_step : 5});
            }
            this.left_menu_list.push({active_class: "", img_src:  require("../../assets/image/process06_on.png"), menu_name : "결제" , nomal_step : 6});
            this.left_menu_list.push({active_class: "", img_src:  require("../../assets/image/process07_on.png"), menu_name : "완료" , nomal_step : 7});
        },
        //250514 이용안내 팝업용으로 추가
        async get_usage_guide(){
            const type = config.REQ_GET_USAGE_GUIDE;
            const data = {
                store_id: this.$store.getters['getStoreInfo'].store_id,
            };
            try {
                const response = await this.$store.dispatch(type.action_name, {
                    type: type,
                    data: data
                });
                if(response.use_yn == 'y'){
                    return response;
                }
                return null;
            } catch (error) {
                console.log('error=============>', error);
                return null;  //실패시 대비
            }
        },
        async open_guide(){
            let send_data = null;
            const result = await this.get_usage_guide();
            if (result) {
                send_data = { 
                            seat_guide: result.seat_guide, 
                            locker_guide: result.locker_guide, 
                            groom_guide: result.groom_guide
                        }
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_USE_GUIDE,
                    data: send_data
                }
                this.$store.commit('set_popup_type', alert_param);
            }
        }
    },

    mounted() {
        this.$nextTick(function () {
            this.refund = this.$store.getters['get_refund_text'];
            // main 쪽 좌석 라커 그룹룸 보여주게할 값 셋팅
            this.$store.commit('change_main_tab_chk', {
                value: 0  // =>0좌석 1 사물함 2 그룹룸
            });
            var yndata = this.$store.getters['getUseyn'];
            if(typeof yndata == "undefined"){
                this.sale_use_yn = 0;
                this.mileage_use_yn = 0;
            }else{
                /*
                this.sale_use_yn = yndata.groom_sale_yn;
                this.mileage_use_yn = yndata.groom_use_yn;
                this.use_min_unit = yndata.use_min_unit;
                this.use_min_amount = yndata.use_min_amount;
                */
            }
            this.get_left_menu();
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth() + 1; //January is 0!
            var yyyy = today.getFullYear();
            var h = today.getHours();
            var m = today.getMinutes();
            if (h < 10) {
                h = '0' + h;
            }
            if (m < 10) {
                m = '0' + m;
            }
            var currentTime = today.getHours() + "시 " + today.getMinutes() + "분 ";
            var currentTime_server = h + ':' + m + ':' + '00';
            if (dd < 10) {
                dd = '0' + dd
            }
            if (mm < 10) {
                mm = '0' + mm
            }
            this.now_date = today = yyyy + '-' + mm + '-' + dd + ' ' + currentTime_server;

            // 상품구매 아이템 데이터 호출
            // 기타상품 타입 리스트
            const type = config.REQ_ETC_GOODS_GET_LIST;
            const data = {}; // store_id는 공통으로 추가하니까 생략. 예) {user_id: 123}
            this.$store.dispatch(type.action_name, {
                type: type,
                data: data
            }).then(response => {
                this.etc_product_list = response.data;
                if(this.etc_product_list.length != 0){
                    for(var i = 0; i < this.etc_product_list.length; i++){
                        this.etc_product_list[i].active_class = '';
                    }
                }
            }).catch(function (error) {
                console.log('error=============>', error);
            });

            // 250514 이용안내 추가 
            this.get_usage_guide()
            .then(result => {
                if (result && result.use_yn === 'y') {
                    this.usage_guide_useyn = 'y';
                    this.usage_guide_data = result;
                }
            })
            .catch(error => {
                console.log('error=============>', error);
            });

        });

    },
    beforeDestroy(){
        this.$store.commit('set_payment_Start', false);
    },
    watch:{
        step(){
            for(var i = 0; i < this.left_menu_list.length; i++){
                this.left_menu_list[i].active_class = '';
                if(this.left_menu_list[i].nomal_step == (this.step+1)){
                    this.left_menu_list[i].img_src = require("../../assets/image/process0"+(this.left_menu_list[i].nomal_step)+"_on.png");
                    this.left_menu_list[i].active_class = 'process_on';
                    for (var n=0; n<i; n++) {
                        this.left_menu_list[n].active_class = 'process_finish';
                    }
                }else{
                    this.left_menu_list[i].img_src = require("../../assets/image/left_ico_0"+(this.left_menu_list[i].nomal_step)+".png");
                }
            }
        }
    }
}
</script>

<style>
</style><style>
.vdp-datepicker .vdp-datepicker__calendar {
    position: relative;
    width: 355%;
    height: 100%;

}
</style>



// WEBPACK FOOTER //
// src/components/page/Payment_etc.vue